export enum AlertEnabledState {
    Enabled = 'Enabled',
    Disabled = 'Disabled',
    PartiallyEnabled = 'PartiallyEnabled',
}
